const Shimmer = () => (

    <div className="shimmer-container">
        <div className="shimmer-card"><div className="shimmer-img-box"></div></div>
        <div className="shimmer-card"><div className="shimmer-img-box"></div></div>
        <div className="shimmer-card"><div className="shimmer-img-box"></div></div>
        <div className="shimmer-card"><div className="shimmer-img-box"></div></div>
        <div className="shimmer-card"><div className="shimmer-img-box"></div></div>
        <div className="shimmer-card"><div className="shimmer-img-box"></div></div>
        <div className="shimmer-card"><div className="shimmer-img-box"></div></div>
        <div className="shimmer-card"><div className="shimmer-img-box"></div></div>
    </div>
    
)

export default Shimmer;